import { useEffect, useRef } from 'react';

function MyIntegratorInvoices() {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // const scriptSrc ='https://pacific-automation-invoice.loc/src/invoice/invoice.js';
    const scriptSrc =
      'https://pacificautomation.com.au/content/buyers-portal/invoice-module/src/invoice/invoice.js';

    // Check if the script is already in the document
    const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
    if (existingScript) return;

    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    containerRef.current.appendChild(script);
  }, []);

  return (
    <div>
      <div id="myIntegratorInvoices" ref={containerRef} />
    </div>
  );
}

export default MyIntegratorInvoices;
